import "../STCreate/PureComponents/STCreate.css";

import React, { useEffect, useState } from "react";
import {
  addingMultipleFilesST,
  createInternalServiceTicket,
} from "Config/API/action";
import {
  getAssignTech,
  getCategoryData,
  getLocationData,
  getTicketId,
} from "Config/API/get";
import { useLocation, useNavigate } from "react-router-dom";
import Headers from "Components/Header/Headers";
import { Link } from "react-router-dom";
import Navigation from "Components/SideNavBar/Navigation";
import StorageLimitReachedPopup from "Components/Popup/StorageLimitReachedPopup/StorageLimitReachedPopup";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import useIsStorageLimitReached from "Hooks/useIsStorageLimitReached";
import { useDispatch, useSelector } from "react-redux";
import { servicePageTypeAction } from "Redux/action/render.action";
import getFileIcon from "../Common/getFileIcon";

const FILE_INPUT_ACCEPT =
  ".png,.jpg,.jpeg,.pdf, .docx, .doc, .xlsx, .xls, .csv, .mp4";
const READ_ONLY_FIELD_STYLE = { backgroundColor: "#f1f2f6" };

const CreateInternalTicketGeneral = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const isStorageLimitReached = useIsStorageLimitReached();
  const orgName = useSelector(
    (state) => state.renderGeneralInfo?.organization_name
  );
  const general_info = useSelector((state) => state.renderGeneralInfo);
  const previousUserData = useSelector(
    (state) => state.raiseRequestDataReducer
  );
  const token = localStorage.getItem("token");
  const [loader, setLoader, resetLoader] = useFullPageLoader();

  // folder the ticket is connected to (only set when opened from an existing request)
  const [folder, setFolder] = useState("");
  const [folderLink, setFolderLink] = useState("");
  const [folderId, setFolderId] = useState("");

  // input fields
  const [ticketId, setTicketId] = useState("");
  const [severity, setSeverity] = useState("none");
  const [desc, setDesc] = useState("");
  const [files, setFiles] = useState([]);
  const [location_list, setLocation_list] = useState([]);
  const [location, setLocation] = useState("");
  const [teams, setTeams] = useState([]);
  const [category_id, setCategory_id] = useState("");
  const [assignedTech, setAssignedTech] = useState([]);
  const [assign_tech, setAssign_tech] = useState("");
  const [raise_request_id] = useState(previousUserData[2] || "");

  // to show popups
  const [showStorageLimitReachedPopup, setShowStorageLimitReachedPopup] =
    useState(false);
  const [ticketData, setTicketData] = useState([]);

  const hasNoTicketData =
    !ticketData || Object.keys(ticketData).length === 0;
  const hasNoTicketFiles =
    !ticketData?.files || ticketData.files.length === 0;

  // firstly getting ticket id
  useEffect(() => {
    getTicketId(token).then((res) => {
      if (res?.status) {
        setTicketId(res?.ticketId);
      }
    });
    if (state === "new ticket" || state?.type === "new ticket") {
      setTicketData([]);
    } else {
      setTicketData(previousUserData[6]);
      setFolder(previousUserData[6]?.connect_folder_name);
      setFolderLink(previousUserData[6]?.connect_folder);
      setFolderId(previousUserData[6]?.connect_folder_id);
    }
    getAllLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getCategoryData(token, general_info?.org_id, location).then((res) => {
      setTeams(res?.category);
    });
  }, [location]);

  useEffect(() => {
    getAssignTech(
      token,
      location || ticketData?.location,
      category_id || ticketData?.category_id
    ).then((res) => {
      setAssignedTech(res?.data);
    });
  }, [category_id, ticketData?.category_id]);

  const getAllLocations = () => {
    getLocationData(token, general_info?.org_id).then((res) => {
      if (res?.location?.length > 0) {
        setLocation_list(res?.location);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (ticketId === "") return;
    if (severity === "none")
      return toast("Please select severity of ticket", { type: "info" });

    setLoader();
    const folder_name =
      folderId?.toString() === "" && folderLink?.toString() === ""
        ? folder
        : folderId;

    createInternalServiceTicket(
      token,
      ticketId,
      severity,
      "",
      folderLink,
      folder_name,
      ticketData?.files ? ticketData?.files : files,
      desc,
      ticketData?.location ? ticketData?.location : location,
      ticketData?.category_id ? ticketData?.category_id : category_id,
      assign_tech,
      raise_request_id,
      ""
    )?.then((res) => {
      resetLoader();
      if (res?.status) {
        if (res?.message === "Ticket already created")
          return toast(res?.message, { type: "info" });
        toast(res?.message, { type: "success" });
        dispatch(servicePageTypeAction("PREMIUM"));

        navigate("/all-internal-service-tickets");
      } else {
        toast(res?.message, { type: "error" });
      }
    });
  };

  const handleFilesSelected = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const totalSize = selectedFiles.reduce((sum, file) => sum + file.size, 0);
    if (isStorageLimitReached(totalSize))
      return setShowStorageLimitReachedPopup(true);

    setLoader();
    addingMultipleFilesST(token, ticketId, e.target.files, "false").then(
      (res) => {
        res.json().then((response) => {
          if (response?.status) {
            if (response?.message?.includes("limit"))
              return toast(response?.message, { type: "info" });
            setFiles(response?.data);
          } else {
            toast(response?.message, { type: "info" });
          }
        });
        resetLoader();
      }
    );
  };

  return (
    <>
      <div className="stcreate-parent">
        <div className="stcreate-header">
          <Headers />
        </div>

        <div className="stcreate-navigation">
          <Navigation />
        </div>

        <div className="stcreate-main">
          <form
            className="stcreate-form-body"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div className="stcreate-heading">
              <p>Create A New Internal Ticket</p>
            </div>
            <div className="stcreate-wrapper">
              <div className="stcreate-fields">
                <label htmlFor="ticket-no">
                  Ticket # (Auto Generate)<span>*</span>:
                </label>
                <input
                  type="text"
                  id="ticket-no"
                  value={ticketId}
                  required
                  readOnly
                />
              </div>

              <div className="stcreate-fields">
                <label htmlFor="organization">
                  Organization<span>*</span>:
                </label>

                <input
                  type="text"
                  id="organization"
                  value={orgName}
                  required
                  readOnly
                />
              </div>

              <div className="stcreate-fields">
                <label htmlFor="severity">
                  Select Severity Of Issue<span>*</span>:
                </label>

                <select
                  required
                  id="severity"
                  className="severity-wrapper"
                  defaultValue={severity}
                  onChange={(e) => setSeverity(e.target.value)}
                >
                  <option className="severity-row" value="none" disabled>
                    -- Select an option --
                  </option>
                  <option className="severity-row" value="urgent">
                    Urgent
                  </option>
                  <option className="severity-row" value="moderate">
                    Moderate
                  </option>
                  <option className="severity-row" value="low">
                    Low
                  </option>
                </select>
              </div>

              <div className="stcreate-fields stcreate-file-upload">
                <label htmlFor="file">Upload Files:</label>
                <div className="files-wrappper">
                  <div style={{ width: "100%", marginTop: "10px" }}>
                    {ticketData?.files?.length !== 0 ? (
                      ticketData?.files?.map((curr, inx) => (
                        <div className="file-upload" key={inx}>
                          <Link
                            className="file-upload-link"
                            to={`/app-file-viewer`}
                            onClick={() => {
                              localStorage.setItem("filePath", curr?.path);
                              localStorage.setItem(
                                "fileType",
                                curr?.aws_name?.split(".").at(1)
                              );
                            }}
                          >
                            <img
                              src={getFileIcon(curr?.aws_name)}
                              alt="File Icon"
                              className="file-upload-image"
                            />
                            {curr?.aws_name
                              ? curr?.aws_name
                              : "unsupported format"}
                          </Link>
                        </div>
                      ))
                    ) : (
                      <input
                        type="text"
                        id="files"
                        className="ticket-files"
                        value={"Not Found"}
                        style={READ_ONLY_FIELD_STYLE}
                        readOnly
                        required
                      />
                    )}
                  </div>
                  {hasNoTicketFiles && (
                    <input
                      type="file"
                      id="file"
                      style={{ padding: "2px" }}
                      multiple
                      accept={FILE_INPUT_ACCEPT}
                      onChange={handleFilesSelected}
                    />
                  )}
                </div>
              </div>
              <div className="straisereq-fields">
                <label htmlFor="contact-email">
                  Location<span>*</span>:
                </label>
                {hasNoTicketData ? (
                  <select
                    required
                    className="severity-wrapper"
                    onChange={(e) => {
                      setLocation(e.target.value);
                      setCategory_id(""); // Reset category/team selection
                      setAssign_tech(""); // Reset user selection
                    }}
                    name="location"
                  >
                    <option key="" value="" selected disabled>
                      -- Select an option --
                    </option>
                    {location_list?.map((item) => (
                      <option
                        key={item?.key}
                        label={item?.location}
                        value={item?.id}
                      >
                        {item?.location}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    style={READ_ONLY_FIELD_STYLE}
                    type="text"
                    value={ticketData?.locationName}
                    id="contact-email"
                    readOnly
                    required
                  />
                )}
              </div>
              <div className="stcreate-fields">
                <label htmlFor="severity">
                  Select Team<span>*</span>:
                </label>
                {hasNoTicketData ? (
                  <select
                    required
                    id="team"
                    name="team"
                    className="severity-wrapper"
                    onChange={(e) => {
                      setCategory_id(e.target.value);
                      setAssign_tech("");
                    }}
                    value={category_id}
                    disabled={location === ""}
                  >
                    <option key="" value="" selected disabled>
                      -- Select an option --
                    </option>
                    {teams?.length > 0 ? (
                      teams.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.category_id}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Team Found</option>
                    )}
                  </select>
                ) : (
                  <input
                    style={READ_ONLY_FIELD_STYLE}
                    type="text"
                    value={ticketData?.categoryName}
                    id="contact-email"
                    readOnly
                    required
                  />
                )}
              </div>

              <div className="stcreate-fields">
                <label htmlFor="severity">
                  Select User<span>*</span>:
                </label>
                <select
                  required
                  id="user"
                  name="user"
                  className="severity-wrapper"
                  disabled={
                    ticketData?.length === 0 &&
                    location === "" &&
                    category_id === ""
                  }
                  onChange={(e) => setAssign_tech(e.target.value)}
                  value={assign_tech} // Ensure reset works
                >
                  <option key="" value="" selected disabled>
                    -- Select an option --
                  </option>
                  {assignedTech?.length > 0 ? (
                    assignedTech.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.username}
                      </option>
                    ))
                  ) : (
                    <option disabled>No User Found</option>
                  )}
                </select>
              </div>
              <div className="stcreate-fields">
                <label htmlFor="description">
                  Brief Description<span>*</span>:
                </label>
                <textarea
                  id="description"
                  rows="5"
                  onChange={(e) => setDesc(e.target.value)}
                  name="description"
                  required
                ></textarea>
              </div>

              <div className="stcreate-fields">
                <button type="submit">Create New Ticket</button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {showStorageLimitReachedPopup && (
        <StorageLimitReachedPopup hide={setShowStorageLimitReachedPopup} />
      )}
      {loader}
    </>
  );
};

export default CreateInternalTicketGeneral;
